import { FormControl, MenuItem, Select } from "@mui/material";
import PropTypes from "prop-types";
import { ADMIN_COMPANY_SELECT_OPTIONS } from "../../constants/discoCompanies";
import { isSelectableCompanyDropdownOption } from "../../utils/adminCompany";

export const ADMIN_COMPANY_SELECT_SX = {
  backgroundColor: "white",
  borderRadius: "8px",
  fontSize: "13px",
  height: "36px",
  boxSizing: "border-box",
  "& .MuiSelect-select": {
    paddingTop: "6px",
    paddingBottom: "6px",
    display: "flex",
    alignItems: "center",
  },
};

const AdminCompanySelect = ({
  value,
  onChange,
  minWidth = 180,
  size = "small",
  placeholder = "Select Company",
  includePitc = true,
  disabled = false,
  restrictToEnabled = true,
  className,
  sx,
}) => {
  const options = includePitc
    ? ADMIN_COMPANY_SELECT_OPTIONS
    : ADMIN_COMPANY_SELECT_OPTIONS.filter((option) => option.value !== "10");

  return (
    <FormControl
      size={size}
      sx={{ minWidth, overflow: "visible" }}
      className={`admin-company-select${className ? ` ${className}` : ""}`}
    >
      <Select
        value={value ?? ""}
        onChange={(event) => onChange?.(event.target.value)}
        displayEmpty
        disabled={disabled}
        variant="outlined"
        sx={{ ...ADMIN_COMPANY_SELECT_SX, ...sx }}
        MenuProps={{
          PaperProps: {
            className: "admin-company-select-menu",
          },
        }}
      >
        <MenuItem value="">{placeholder}</MenuItem>
        {options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            disabled={
              restrictToEnabled &&
              !isSelectableCompanyDropdownOption(option.value, value)
            }
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

AdminCompanySelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  minWidth: PropTypes.number,
  size: PropTypes.oneOf(["small", "medium"]),
  placeholder: PropTypes.string,
  includePitc: PropTypes.bool,
  disabled: PropTypes.bool,
  restrictToEnabled: PropTypes.bool,
  className: PropTypes.string,
  sx: PropTypes.object,
};

export default AdminCompanySelect;
